import { render, staticRenderFns } from "./ShuttleList.vue?vue&type=template&id=3b5b8d0e&scoped=true"
import script from "./ShuttleList.vue?vue&type=script&lang=js"
export * from "./ShuttleList.vue?vue&type=script&lang=js"
import style0 from "./ShuttleList.vue?vue&type=style&index=0&id=3b5b8d0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b5b8d0e",
  null
  
)

export default component.exports